import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "./styles/index.scss";
import Root from "./Root";

ReactDOM.render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>,
  document.getElementById("root")
);
